import { createContext, useContext } from 'react';

const FeatureFlagsContext = createContext({
  issuerInstallmentsCardBrands: [],
  issuerInstallmentsEnabled: false,
  recommendedProductsEnabled: false,
  mpoPhase3Enabled: false,
  saasOnShopEnabled: false,
  savedCardsEnabled: false,
  checkingVyiFlowEnabled: false,
  addressValidationEnabled: false,
  hideKioskAddOnForSquareOneExperimentEnabled: false,
  show1PPDisclaimerOnPDP: false,
});

/*
  Custom hook to extract feature flag details

  Usage:
    const featureFlag = useFeatureFlags();
    mpoPhase3Enabled = featureFlag.mpoPhase3Enabled;
    recommendedProductsEnabled = featureFlag.recommendedProductsEnabled;
 */
const useFeatureFlags = () => {
  return useContext(FeatureFlagsContext);
};

/*
  Provides a component that wraps your app with
  details about feature flags
 */
const FeatureFlags = (props) => {
  const values = {
    recommendedProductsEnabled:
      props?.featureFlags?.recommended_products_enabled || false,
    mpoPhase3Enabled: props?.featureFlags?.mpo_phase3_enabled || false,
    saasOnShopEnabled: props?.featureFlags?.saas_on_shop_enabled || false,
    issuerInstallmentsEnabled:
      props?.featureFlags?.issuer_installments_enabled || false,
    issuerInstallmentsCardBrands:
      props?.featureFlags?.issuer_installments_card_brands || [],
    savedCardsEnabled: props?.featureFlags?.saved_cards_enabled || false,
    checkingVyiFlowEnabled:
      props?.featureFlags?.checking_vyi_flow_enabled || false,
    addressValidationEnabled:
      props?.featureFlags?.enable_address_validation || false,
    hideKioskAddOnForSquareOneExperimentEnabled:
      props?.featureFlags
        ?.hide_kiosk_add_on_for_square_one_experiment_enabled || false,
    show1PPDisclaimerOnPDP:
      props?.featureFlags?.show_1pp_disclaimer_on_pdp || false,
    addressValidationPromptExperimentEnabled:
      props?.featureFlags?.address_validation_prompt_experiment_enabled ||
      false,
  };

  return (
    <FeatureFlagsContext.Provider value={values}>
      {props.children}
    </FeatureFlagsContext.Provider>
  );
};

export { FeatureFlags, useFeatureFlags };
